var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutDev2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-180"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-180",
    cx: 249.05,
    cy: 313.84,
    rx: 211.54,
    ry: 133.12,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-180"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 322.65,
    cy: 390.86,
    rx: 46.65,
    ry: 26.93,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gear--inject-180"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61,196.5l.18.1-.23-.12-.43-.25Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.71,194a.63.63,0,0,0,0,.36.55.55,0,0,1,0-.36l.66-2.2Z",
    style: {
      fill: "#61A5C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.71,194a.63.63,0,0,0,0,.36.55.55,0,0,1,0-.36l.66-2.2Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.17,162.28l-12.29-7.12a.55.55,0,0,0-.14-.08.59.59,0,0,0-.23-.05l-1-.53-1.31-.77-5.3-3.07-.82-.47c-1-.58-1.63-.94-1.67-1a1,1,0,0,0-.61-.12l-6.19.62a1.84,1.84,0,0,0-1,.49,1.14,1.14,0,0,0-.32.45l-3.36,9s0,0,0,.06l-.09.17a.68.68,0,0,1-.13.18,2.85,2.85,0,0,1-.23.26,3.5,3.5,0,0,1-.64.51l-.23.13a21.94,21.94,0,0,0-2,1l-6.49-3.77a.61.61,0,0,0-.28-.07,1,1,0,0,0-.72.37h0l-4.06,4.3-2.73,2.88a2.13,2.13,0,0,0-.48.85,1.11,1.11,0,0,0,0,.64l1.9,6.4a.57.57,0,0,1,0,.23.93.93,0,0,1,0,.4,1.31,1.31,0,0,1-.06.27s0,.05,0,.06a.23.23,0,0,1,0,.1.6.6,0,0,1-.08.2,1.32,1.32,0,0,1-.15.29,49.09,49.09,0,0,0-3.12,5.43.7.7,0,0,1-.15.2,1.86,1.86,0,0,1-.19.22,2.37,2.37,0,0,1-1.14.66L62,183.07a2,2,0,0,0-1.11.71,1.2,1.2,0,0,0-.21.38l-.36,1.23-1.91,6.43-.65,2.2a.67.67,0,0,0,.07.55.57.57,0,0,0,.15.16l.1.07,1,.56.27.16h0l.78.45.42.25.48.27.18.1.51.3,2.83,1.63a0,0,0,0,1,0,0,25.42,25.42,0,0,0,.11,2.64,1.83,1.83,0,0,1-.12.72,2.71,2.71,0,0,1-.45.84l-5.93,7.18a1.81,1.81,0,0,0-.37.73c0,.07,0,.15,0,.22a.88.88,0,0,0,0,.52l2.82,6.23a.62.62,0,0,0,.08.12.27.27,0,0,0,.1.08l0,0L65,220.28c.36.2.73.43,1.11.65l4.1,2.37.48.28,2.55,1.47a.41.41,0,0,1-.16-.2l-2.81-6.21a1.12,1.12,0,0,1,0-.75,2,2,0,0,1,.37-.73L76.54,210a2.7,2.7,0,0,0,.47-.85,1.81,1.81,0,0,0,.11-.72,28,28,0,0,1,0-5.1.86.86,0,0,0-.89-.87l-5.32-.3a.94.94,0,0,1-.42-.12l0,0a.63.63,0,0,1-.27-.74l2.57-8.66.36-1.2a1.2,1.2,0,0,1,.24-.42,2.14,2.14,0,0,1,1.07-.67l5.82-1.4a2.66,2.66,0,0,0,1.16-.69,1.64,1.64,0,0,0,.31-.41,52.45,52.45,0,0,1,3.13-5.42,2.33,2.33,0,0,0,.37-1.34v0a.58.58,0,0,0,0-.19l-1.89-6.4a1.29,1.29,0,0,1,.06-.71,2.09,2.09,0,0,1,.47-.78l.09-.1,6.7-7.08a.91.91,0,0,1,.94-.33l.05,0a.43.43,0,0,1,.16.14l3.16,4.84c.23.35.81.32,1.33,0a27.47,27.47,0,0,1,3.83-2.21,2.92,2.92,0,0,0,1.33-1.26l0,0,3.36-9a1.23,1.23,0,0,1,.33-.47,1.72,1.72,0,0,1,1-.47l6.19-.62a1.13,1.13,0,0,1,.54.07l0,0a.56.56,0,0,1,.27.63l-2,8.84a1,1,0,0,0,.64,1.12,9.88,9.88,0,0,1,2.7,1.57,1.13,1.13,0,0,0,1.39-.24l6.32-5.77A.93.93,0,0,1,123.17,162.28Z",
    style: {
      fill: "#61A5C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.48,181.6c0,.81,0,1.63-.12,2.48a.87.87,0,0,0,.89.87l5.31.3a.8.8,0,0,1,.39.09Z",
    style: {
      fill: "#61A5C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.54,216.94c-.22-.35-.8-.33-1.32,0s-1.25.81-1.86,1.18l6.51,3.78v0a.38.38,0,0,1-.16-.13Z",
    style: {
      fill: "#61A5C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6,220.35a9.58,9.58,0,0,1-2.71-1.57,1.1,1.1,0,0,0-1.38.24l-6.32,5.78a1.11,1.11,0,0,1-.69.31l10,5.82a.55.55,0,0,1-.26-.6l2-8.87A1,1,0,0,0,84.6,220.35Z",
    style: {
      fill: "#61A5C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103,204.21a17.77,17.77,0,0,1-8,5.22l-.34.08-.24.06-.55.09-.64.06h-.59a6.22,6.22,0,0,1-5.83-3.91,10.79,10.79,0,0,1-.85-3.25c.48-.22,1-.48,1.47-.76,6.87-4,12.43-13.6,12.43-21.53,0-.6,0-1.17-.07-1.69a9.74,9.74,0,0,1,4.39-.93h.27l.22,0,.24,0a6.21,6.21,0,0,1,4.87,3.84C112.35,187.38,109.34,197.52,103,204.21Z",
    style: {
      fill: "#61A5C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103,204.21a17.77,17.77,0,0,1-8,5.22l-.34.08-.24.06-.55.09-.64.06h-.59a6.22,6.22,0,0,1-5.83-3.91,10.79,10.79,0,0,1-.85-3.25c.48-.22,1-.48,1.47-.76,6.87-4,12.43-13.6,12.43-21.53,0-.6,0-1.17-.07-1.69a9.74,9.74,0,0,1,4.39-.93h.27l.22,0,.24,0a6.21,6.21,0,0,1,4.87,3.84C112.35,187.38,109.34,197.52,103,204.21Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,185.36s0,0,0,0a.85.85,0,0,0-.38-.1l-5.31-.3a.86.86,0,0,1-.89-.86c.07-.84.11-1.67.12-2.48a22.9,22.9,0,0,0-.12-2.64,2.63,2.63,0,0,1,.59-1.57l5.92-7.17a1.6,1.6,0,0,0,.36-1.47l-2.81-6.23a.41.41,0,0,0-.18-.19l0,0c-.23-.12-.58,0-.91.28L116,168.37a1.11,1.11,0,0,1-1.38.23,10,10,0,0,0-2.7-1.57,1,1,0,0,1-.64-1.11l2-8.86a.55.55,0,0,0-.27-.62,1.06,1.06,0,0,0-.59-.11l-6.18.62a1.73,1.73,0,0,0-1.36,1l-3.35,9a2.86,2.86,0,0,1-1.35,1.31,27.56,27.56,0,0,0-3.83,2.22c-.52.35-1.1.37-1.33,0l-3.17-4.84c-.22-.34-.73-.27-1.14.16l-6.79,7.17a1.79,1.79,0,0,0-.53,1.49l1.89,6.41a2.16,2.16,0,0,1-.34,1.54,54.64,54.64,0,0,0-3.13,5.42,2.47,2.47,0,0,1-1.47,1.11l-5.82,1.4a1.91,1.91,0,0,0-1.31,1.09l-2.93,9.85a.7.7,0,0,0,.72.89l5.32.3a.86.86,0,0,1,.89.86,27.38,27.38,0,0,0,0,5.12,2.49,2.49,0,0,1-.58,1.56l-5.92,7.18a1.6,1.6,0,0,0-.36,1.48l2.81,6.22a.4.4,0,0,0,.17.19h0a.4.4,0,0,0,.22.06h0a1.13,1.13,0,0,0,.7-.32L80.51,219a1.12,1.12,0,0,1,1.38-.23,10.09,10.09,0,0,0,2.71,1.57,1,1,0,0,1,.63,1.11l-2,8.86a.55.55,0,0,0,.26.61h0a.87.87,0,0,0,.58.1l6.18-.61a1.72,1.72,0,0,0,1.36-.94l3.36-9a3,3,0,0,1,1.35-1.31c.65-.3,1.31-.65,2-1s1.25-.76,1.87-1.18,1.1-.38,1.32,0l3.17,4.84a.43.43,0,0,0,.16.14c.25.16.65.05,1-.3l6.8-7.18a1.78,1.78,0,0,0,.52-1.48l-1.89-6.41a2.17,2.17,0,0,1,.35-1.54,50.74,50.74,0,0,0,3.12-5.43,2.47,2.47,0,0,1,1.48-1.09l5.81-1.4a1.88,1.88,0,0,0,1.31-1.1l2.94-9.85A.65.65,0,0,0,126,185.36ZM95,209.42l-.34.09-.25.05a4.85,4.85,0,0,1-.55.09l-.64.07h-.58a6.23,6.23,0,0,1-5.83-3.92,10.73,10.73,0,0,1-.85-3.24,15.15,15.15,0,0,1-.1-1.8c0-5.62,2.92-12.57,7.68-17.59a21.11,21.11,0,0,1,4.69-3.8,12.8,12.8,0,0,1,1.56-.8,9.88,9.88,0,0,1,4.39-.93h.26l.23,0,.24,0a6.22,6.22,0,0,1,4.87,3.85c2.62,5.81-.39,15.94-6.73,22.63A17.74,17.74,0,0,1,95,209.42Z",
    style: {
      fill: "#61A5C2"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110.73,
    y1: 155.08,
    x2: 123.24,
    y2: 162.32,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.42,188.22a2.66,2.66,0,0,1-1.16.69l-5.82,1.4a2.14,2.14,0,0,0-1.07.67l-12.53-7.2a2,2,0,0,1,1.11-.71l5.81-1.41A2.37,2.37,0,0,0,68.9,181h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.23,181l-12.5-7.2a.57.57,0,0,0,0-.23l-1.9-6.4a1.11,1.11,0,0,1,0-.64L80.41,172l3,1.7a1.29,1.29,0,0,0-.06.71l1.89,6.4A.58.58,0,0,1,85.23,181Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.14,157.43a1.23,1.23,0,0,0-.33.47l-3.36,9,0,0-12.51-7.22s0,0,0-.06l3.36-9a1.14,1.14,0,0,1,.32-.45Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.17,162.28a.93.93,0,0,0-.87.31L116,168.36a1.13,1.13,0,0,1-1.39.24,9.88,9.88,0,0,0-2.7-1.57,1,1,0,0,1-.64-1.12l2-8.84a.56.56,0,0,0-.27-.63l0,0c-.18-.1-1.11-.63-2.38-1.38a.59.59,0,0,1,.23.05.55.55,0,0,1,.14.08Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,185.34a.8.8,0,0,0-.39-.09l-5.31-.3a.87.87,0,0,1-.89-.87c.07-.85.12-1.67.12-2.48Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.87,221.91v0l-6.51-3.78c.61-.37,1.24-.76,1.86-1.18s1.1-.38,1.32,0l3.17,4.84A.38.38,0,0,0,104.87,221.91Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.23,221.46l-2,8.87a.55.55,0,0,0,.26.6l-10-5.82a1.11,1.11,0,0,0,.69-.31L80.51,219a1.1,1.1,0,0,1,1.38-.24,9.58,9.58,0,0,0,2.71,1.57A1,1,0,0,1,85.23,221.46Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,209.13a2.7,2.7,0,0,1-.47.85l-5.92,7.18a2,2,0,0,0-.37.73l-12.5-7.23a1.81,1.81,0,0,1,.37-.73l5.93-7.18a2.71,2.71,0,0,0,.45-.84Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.43,166.94a2.92,2.92,0,0,1-1.33,1.26,27.47,27.47,0,0,0-3.83,2.21c-.52.36-1.1.39-1.33,0l-3.16-4.84a.43.43,0,0,0-.16-.14l-.05,0L85.63,162a21.94,21.94,0,0,1,2-1l.23-.13a3.5,3.5,0,0,0,.64-.51,2.85,2.85,0,0,0,.23-.26.68.68,0,0,0,.13-.18l.09-.17Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.12,208.41a1.81,1.81,0,0,1-.11.72L64.5,201.91a1.83,1.83,0,0,0,.12-.72,25.42,25.42,0,0,1-.11-2.64l6,3.45,0,0a.94.94,0,0,0,.42.12l5.32.3a.86.86,0,0,1,.89.87A28,28,0,0,0,77.12,208.41Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.23,181v0a2.33,2.33,0,0,1-.37,1.34,52.45,52.45,0,0,0-3.13,5.42,1.64,1.64,0,0,1-.31.41L68.91,181a.92.92,0,0,0,.18-.22.7.7,0,0,0,.15-.2,49.09,49.09,0,0,1,3.12-5.43,1.32,1.32,0,0,0,.15-.29.6.6,0,0,0,.08-.2.23.23,0,0,0,0-.1s0,0,0-.06a1.31,1.31,0,0,0,.06-.27.93.93,0,0,0,0-.4Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.09,180.78a.92.92,0,0,1-.18.22h0A1.86,1.86,0,0,0,69.09,180.78Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.23,225.05l-2.55-1.47-.48-.28-4.1-2.37c-.38-.22-.75-.45-1.11-.65l-4.21-2.43,0,0a.27.27,0,0,1-.1-.08.62.62,0,0,1-.08-.12l-2.82-6.23a.88.88,0,0,1,0-.52c0-.07,0-.15,0-.22l12.5,7.23a1.12,1.12,0,0,0,0,.75l2.81,6.21A.41.41,0,0,0,73.23,225.05Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.84,183.78a1.2,1.2,0,0,0-.21.38l-.36,1.23-1.91,6.43-.65,2.2a.67.67,0,0,0,.07.55.57.57,0,0,0,.15.16l.1.07,1,.56.27.16h0l.78.45.42.25.48.27.18.1.51.3,2.83,1.63a0,0,0,0,1,0,0l6,3.45a.63.63,0,0,1-.27-.74l2.57-8.66.36-1.2a1.2,1.2,0,0,1,.24-.42Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.63,162l-6.49-3.77a.61.61,0,0,0-.28-.07,1,1,0,0,0-.72.37h0l-4.06,4.3-2.73,2.88a2.13,2.13,0,0,0-.48.85L80.41,172l3,1.7a2.09,2.09,0,0,1,.47-.78l.09-.1,6.7-7.08a.91.91,0,0,1,.94-.33Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.89,156.41a1.13,1.13,0,0,0-.54-.07l-6.19.62a1.72,1.72,0,0,0-1,.47l-12.51-7.22a1.84,1.84,0,0,1,1-.49l6.19-.62a1,1,0,0,1,.61.12s.69.39,1.67,1l.82.47,5.3,3.07,1.31.77,1,.53C111.78,155.78,112.71,156.31,112.89,156.41Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110.88,
    y1: 155.17,
    x2: 110.73,
    y2: 155.09,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-180"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.79,76.39c-.27-2-1.89-2.74-3.82-1.62L153.49,136.24a8.59,8.59,0,0,0-3.87,6.71v235c0,2.28,1.47,3.31,3.38,2.48a8.68,8.68,0,0,1-7.26-.24l-4.43-2.56a8.52,8.52,0,0,1-3.88-6.71V135.93a8.52,8.52,0,0,1,3.88-6.71L247.77,67.74a8.6,8.6,0,0,1,7.75,0L260,70.3A8.63,8.63,0,0,1,263.79,76.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,74.77,153.49,136.24a8.59,8.59,0,0,0-3.87,6.71v235c0,2.47,1.74,3.47,3.87,2.24L260,318.68a8.58,8.58,0,0,0,3.86-6.71V77C263.83,74.54,262.1,73.54,260,74.77Zm-1.71,215.07c0,2.11-1.48,3.46-3.32,4.52l-96.81,55.89c-1.83,1.06-3.32.2-3.32-1.92V165.4a7.36,7.36,0,0,1,3.32-5.76l96.81-55.88c1.84-1.07,3.32-.21,3.32,1.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,380.39a8.68,8.68,0,0,1-7.26-.24l-4.43-2.56a8.53,8.53,0,0,1-3.88-6.71V135.93a7.88,7.88,0,0,1,1.14-3.83l12.19,7a8,8,0,0,0-1.14,3.82v235C149.62,380.19,151.09,381.22,153,380.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.73,111.72c1.43-.83,2.59-.16,2.59,1.5a5.74,5.74,0,0,1-2.59,4.49c-1.44.83-2.6.16-2.6-1.5A5.71,5.71,0,0,1,206.73,111.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.23,124.68c5.27-2.91,14.68-8.51,19.88-11.57.89-.52,1.6-.16,1.6.8a3.48,3.48,0,0,1-1.6,2.67l-19.92,11.5c-.89.51-1.61.15-1.61-.81A3.31,3.31,0,0,1,199.23,124.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.2,127.59c.8-.46,1.45-.09,1.45.84A3.24,3.24,0,0,1,194.2,131c-.81.46-1.46.09-1.46-.84A3.23,3.23,0,0,1,194.2,127.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.92,343.77a3.67,3.67,0,0,1-1.85-.48c-1.31-.76-2-2.32-2-4.39a14.08,14.08,0,0,1,6.37-11c1.79-1,3.5-1.19,4.82-.43s2,2.32,2,4.39a14.1,14.1,0,0,1-6.36,11A6.11,6.11,0,0,1,204.92,343.77Zm5.45-15.8a5.06,5.06,0,0,0-2.47.77A13,13,0,0,0,202,338.9c0,1.7.55,3,1.54,3.52s2.36.42,3.83-.43a13,13,0,0,0,5.86-10.15c0-1.7-.55-2.95-1.54-3.53A2.76,2.76,0,0,0,210.37,328Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.26,105.66V289.85a7.32,7.32,0,0,1-3.32,5.74l-96.81,55.89c-1.83,1-3.32.21-3.32-1.91V338.08l87.91-50.75c1.84-1.06,3.32-2.4,3.32-4.51V108.9l8.9-5.14C256.78,102.7,258.26,103.56,258.26,105.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.94,103.76,246,108.9V282.82a4.65,4.65,0,0,1-2.27,3.82l12.86,7.43a7.26,7.26,0,0,0,1.63-4.22V105.66C258.26,103.56,256.78,102.7,254.94,103.76Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-180"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.66,292.41l-5.54-3.2a.53.53,0,0,1-.26-.23l-1-1.78,3.29-1.9-.1.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.63,285.57l3.84,6.64a.57.57,0,0,0,1-.1l4.06-11.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.72,250.14A5.91,5.91,0,0,0,175,245.5l-2.18-1.26a6,6,0,0,0-5.36,0l-43.39,25a5.91,5.91,0,0,0-2.68,4.64v22a5.93,5.93,0,0,0,2.68,4.64l2.19,1.26a5.93,5.93,0,0,0,5.35,0l43.64-25.21c2.41-1.37,2.43-2.75,2.43-4.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.44,295.88a5.92,5.92,0,0,0,2.67,4.64l2.19,1.26a6,6,0,0,0,4.9.22c-1.26.48-2.22-.24-2.22-1.77v-22a5.5,5.5,0,0,1,.78-2.64l-7.54-4.35a5.4,5.4,0,0,0-.78,2.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.63,249.38c-.31-1.14-1.35-1.5-2.59-.79l-43.39,25a5.35,5.35,0,0,0-1.88,2l-7.54-4.35a5.45,5.45,0,0,1,1.89-2l43.37-25a6,6,0,0,1,5.37,0L175,245.5A5.89,5.89,0,0,1,177.63,249.38Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.18,279.85l31-18c.89-.52,1.62-.28,1.62.53a3.24,3.24,0,0,1-1.62,2.4l-31,18c-.9.52-1.63.28-1.63-.53A3.25,3.25,0,0,1,136.18,279.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.18,287.21l31-18c.89-.52,1.62-.29,1.62.52a3.28,3.28,0,0,1-1.62,2.41l-31,18c-.9.52-1.63.28-1.63-.53A3.25,3.25,0,0,1,136.18,287.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.74,300.52l-5.54-3.2a.53.53,0,0,1-.26-.23l-1-1.78,3.29-1.9-.1.29Z",
    style: {
      fill: "#61A5C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.74,300.52l-5.54-3.2a.53.53,0,0,1-.26-.23l-1-1.78,3.29-1.9-.1.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.71,293.68l3.83,6.64a.58.58,0,0,0,1-.1l4-11.7Z",
    style: {
      fill: "#61A5C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.19,239.05a5.91,5.91,0,0,0-2.68-4.64l-2.18-1.26a5.89,5.89,0,0,0-5.36,0L72.46,262.9a5.91,5.91,0,0,0-2.68,4.64v25.28a5.91,5.91,0,0,0,2.68,4.64l2.18,1.26a5.89,5.89,0,0,0,5.36,0l51.76-29.93c2.41-1.37,2.43-2.75,2.43-4.46Z",
    style: {
      fill: "#61A5C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.78,292.82a5.91,5.91,0,0,0,2.68,4.64l2.18,1.26a6,6,0,0,0,4.9.23c-1.26.47-2.22-.25-2.22-1.78V271.89a5.44,5.44,0,0,1,.79-2.64l-7.54-4.35a5.44,5.44,0,0,0-.79,2.64Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.1,238.29c-.31-1.14-1.35-1.5-2.59-.79L80,267.26a5.22,5.22,0,0,0-1.89,2l-7.54-4.36a5.53,5.53,0,0,1,1.89-2L124,233.15a6,6,0,0,1,5.37,0l2.18,1.26A5.89,5.89,0,0,1,134.1,238.29Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.52,279l27.85-16.13c.9-.52,1.63-.28,1.63.53a3.25,3.25,0,0,1-1.63,2.4L84.52,281.92c-.89.52-1.62.28-1.62-.53A3.26,3.26,0,0,1,84.52,279Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.52,286.35l39.12-22.7c.89-.52,1.62-.28,1.62.53a3.24,3.24,0,0,1-1.62,2.4l-39.12,22.7c-.89.52-1.62.28-1.62-.53A3.26,3.26,0,0,1,84.52,286.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.52,271.27l39.12-22.7c.89-.52,1.62-.28,1.62.53a3.26,3.26,0,0,1-1.62,2.4L84.52,274.2c-.89.52-1.62.28-1.62-.53A3.24,3.24,0,0,1,84.52,271.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.67,108.88l-4.06-2.34h0a1.82,1.82,0,0,0-1.84.18l-88.23,50.94a5.73,5.73,0,0,0-2.6,4.5v45.59a1.79,1.79,0,0,0,.79,1.69h0l4,2.33V208l86-49.65a5.76,5.76,0,0,0,2.6-4.5V110.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.06,163.85l85.31-49.25v-4l3.3-1.68-4.06-2.34h0a1.82,1.82,0,0,0-1.84.18l-88.23,50.94a5.22,5.22,0,0,0-1.84,1.94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.6,160l88.23-50.94c1.44-.83,2.6-.15,2.6,1.5v45.6a5.74,5.74,0,0,1-2.6,4.5L349.6,211.6c-1.44.82-2.6.15-2.6-1.5V164.5A5.77,5.77,0,0,1,349.6,160Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.1,164.44l26.43-15.26c1.67-1,3-.18,3,1.75v30.52a6.69,6.69,0,0,1-3,5.25L354.1,202c-1.68,1-3,.18-3-1.75V169.69A6.7,6.7,0,0,1,354.1,164.44Z",
    style: {
      fill: "#61A5C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.09,163.32c2.8-1.61,5.07-.3,5.07,2.94a11.23,11.23,0,0,1-5.07,8.79c-2.81,1.62-5.08.31-5.08-2.93A11.22,11.22,0,0,1,367.09,163.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.09,180.64c0-5.32-3.73-7.68-8.34-5l-2.88,1.66c-4.6,2.66-8.34,9.13-8.34,14.45v1.43l19.56-11.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.85,143.84l36.29-21c1.19-.69,2.16-.2,2.16,1.1a4.62,4.62,0,0,1-2.16,3.59l-36.29,21c-1.2.69-2.16.2-2.16-1.1A4.62,4.62,0,0,1,393.85,143.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.85,153.22l36.29-21c1.19-.69,2.16-.2,2.16,1.1a4.63,4.63,0,0,1-2.16,3.6l-36.29,20.95c-1.2.69-2.16.2-2.16-1.1A4.62,4.62,0,0,1,393.85,153.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.85,162.6l36.29-20.95c1.19-.69,2.16-.2,2.16,1.09a4.63,4.63,0,0,1-2.16,3.6l-36.29,20.95c-1.2.69-2.16.2-2.16-1.1A4.62,4.62,0,0,1,393.85,162.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.85,172,430.14,151c1.19-.69,2.16-.2,2.16,1.09a4.63,4.63,0,0,1-2.16,3.6l-36.29,20.95c-1.2.69-2.16.2-2.16-1.1A4.62,4.62,0,0,1,393.85,172Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-180"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.79,283.4c0,2.11-1.48,3.46-3.32,4.52l-96.81,55.89c-1.83,1.05-3.32.2-3.32-1.92V159a7.36,7.36,0,0,1,3.32-5.76l96.81-55.88c1.84-1.07,3.32-.21,3.32,1.9Z",
    style: {
      fill: "#61A5C2",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.18,344.76a2.15,2.15,0,0,1-1.12-.29,2.79,2.79,0,0,1-1.22-2.58V159a7.78,7.78,0,0,1,3.57-6.19l96.81-55.89a2.51,2.51,0,0,1,4.07,2.34V283.4c0,2.6-2,4.07-3.57,5l-96.81,55.89A3.47,3.47,0,0,1,190.18,344.76ZM290,97.36a2.54,2.54,0,0,0-1.24.39l-96.81,55.88a6.85,6.85,0,0,0-3.07,5.33V341.89a1.54,1.54,0,0,0,2.57,1.49l96.81-55.9c2.13-1.22,3.07-2.48,3.07-4.08V99.22a1.86,1.86,0,0,0-.72-1.71A1.23,1.23,0,0,0,290,97.36Z",
    style: {
      fill: "#61A5C2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-180"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.46,273.8c.7-26-1.38-32.29-8.32-37.06l-2.68,15.09s3.16,17.79,2.82,23.71c-.3,5.21-.81,11.72-2,15.92a3.17,3.17,0,0,1-1.38,1.79c-1.76,1.1-2.48,2.24-3.81,3.63-1,1.09-1.92,1.36-1.79,1.71a1.72,1.72,0,0,0,2.2.77A11.57,11.57,0,0,0,332,298a15.73,15.73,0,0,1-2.56,4.4c-2.48,3-2.59,4.9,2.41,4.95,3.14,0,5.63-1.91,8-8.81a56.31,56.31,0,0,0,2.2-7.75C343.2,284,344.35,278,344.46,273.8Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.31,234.76A10,10,0,0,1,341,240.18c2.91,5.19,3.62,14.13,4,23,0,0-5.77,4.82-12.69,2.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.05,378c.52.2.65,1.2.73,3.19.06,1.5.39,4.13-1.38,4.66s-4.35.26-5.48-1.16a68.22,68.22,0,0,0-4.38-5.5c-1.74-1.87-3.63-3.62-4.34-6.25-.63-2.38-.1-3.41,1.52-4.1,2.23-.95,5.73,2.15,7.48,2.64C335.7,371.92,339.52,377.82,340.05,378Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.05,376.17v2.45a6,6,0,0,1-6.18.16c-.11-.23-.64-3.49-.64-3.49Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.25,392.1a39,39,0,0,1,1.08,4c.3,1.47.73,3.94.22,5.05S319,403,315.88,403c-2,0-5.18,1.36-7.35,2.57s-6.87,1.74-9.24,1.46c-2.78-.33-5.66-1.94-6.11-3.09s.14-2.35,6.7-5.15c.06,0,9.13-3,12.3-6.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.25,389.46v2.85c0,1-1.21,2.58-4.38,2.47-2.22-.08-3.78-.68-3.69-2.51v-2.65Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.64,343.74A66.49,66.49,0,0,0,338.75,331s.87-11,1.29-21.39c.45-11.25,0-25.38.19-28.19,0,0-36.29-7.34-36.94,5.66s1.44,46.09,1.86,51.81,1.42,10.76,2.6,20,4.43,30.71,4.43,30.71a8.54,8.54,0,0,0,8.07-.16s2.56-26,2.29-32.59a56.43,56.43,0,0,0-2.5-14.38s.69-10.72,1.3-20,1.25-13.81,1.39-17.86l.78-.39s.8,16.09,1.22,21.8,1.34,11.18,3,21.79c1.44,9.21,5.71,28.68,5.71,28.68,4.14,2.24,6.62-.3,6.62-.3S342.75,351.73,341.64,343.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.73,304.59s8.8-4.34,13.21-8.25c0,0-4.09,5.76-9.46,8.32,0,0-1.91,20-1.9,19.58l-1.11-19.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.89 230.65 317.04 242.47 327.72 241.69 325.48 228.29 314.89 230.65",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,240.82c-1.06-3.21-5.13-6.71-9.21-5.95a120.32,120.32,0,0,0-17.87,4.46c-3.73,1.33-7.14,4.56-7.45,16.85,0,0-1.25,28.64-1.27,34.18a45.3,45.3,0,0,0,24.53,2.42c11.22-2.45,12.57-7.11,12.57-7.11s.15-20.59-.19-29.49C339.82,248.62,339.72,243,339,240.82Z",
    style: {
      fill: "#61A5C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.66,216.27s-2.71,4.32-2.38,4.73,2.4.74,2.4.74Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.17,204.33c-5.64,1.32-7.22,3.85-7.55,12.88-.35,9.42.68,12.36,1.94,13.6.86.84,5.5.89,7.83.19,2.91-.87,9.48-3.37,12.47-8.17,3.52-5.66,4.31-13.23.34-16.24C323.6,202.35,316.47,203.79,314.17,204.33Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.68,206.68a11.52,11.52,0,0,0,5.25,4.19c1.08,1.23.49,6,2.39,6.81,0,0,.82-3.51,3.76-3.13s3.45,4.12,1.64,6.45-3.56,1.49-3.56,1.49.2,5,2.47,7.74c0,0,2.52.76,7.12-.33,2.82-.67,6.75-4.3,8.35-8.09,3.38-8,3.47-15.17-1.64-17.2-.63-3.64-3.55-5.22-6.85-5.9-7.11-1.47-11.69,3-17.16,2.58C305.32,201.07,304.74,203.35,306.68,206.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.57,205.83l3.35-2.07a2,2,0,1,0-3.35,2.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.77,260.61c1.75.78,22.44,16.06,25.66,14.28s19.77-21.11,19.77-21.11a13.34,13.34,0,0,0,0-14.5s-5.3,1-8.08,5.18-14.76,19.23-14.76,19.23q-4.44-2.22-8.86-4.5c-2.42-1.26-4.85-2.51-7.22-3.86a9.39,9.39,0,0,1-1.87-1.15c-1.17-1.16-1-4-.94-5.48,0-.71,0-1.42.1-2.13.1-.87.27-3-1.3-2.32a2,2,0,0,0-.75.62,3.9,3.9,0,0,0-.56,1.07c-.29.92-.2,1.93-.47,2.86a.87.87,0,0,1-.19.37.72.72,0,0,1-.49.15c-2.28-.07-4.44-3.26-5.49-5a4.5,4.5,0,0,0-1.73-2c-1.24-.58-2.74.25-3.55,1.37a7.18,7.18,0,0,0-1.12,5,10,10,0,0,0,3,6.3A30.65,30.65,0,0,0,266.77,260.61Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.89,238.66c-2.28.26-6.07.43-9.79,4.64-4.34,4.91-10.06,12.94-10.06,12.94a12.69,12.69,0,0,0,10,9.42s7.83-8,10-12.43S316.58,241.64,313.89,238.66Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chart--inject-180"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.8,136.79V105.26l18.62,12.31C367,126.05,360.91,132.36,353.8,136.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.8 105.26 346.35 100.96 346.35 132.49 353.8 136.79 353.8 105.26",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.23 81.38 355.32 101.45 347.87 97.16 375.78 77.08 383.23 81.38",
    style: {
      fill: "#61A5C2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.23 81.38 355.32 101.45 347.87 97.16 375.78 77.08 383.23 81.38",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.23,81.38c.76,10.18-2.24,21.43-8.73,32.75l-11.64-7.69-7.54-5Z",
    style: {
      fill: "#61A5C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.23,81.38c.76,10.18-2.24,21.43-8.73,32.75l-11.64-7.69-7.54-5Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.5 114.13 367.05 109.83 347.87 97.16 355.32 101.45 374.5 114.13",
    style: {
      fill: "#61A5C2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.5 114.13 367.05 109.83 347.87 97.16 355.32 101.45 374.5 114.13",
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.15,87.68l-5.32-21.57c.75-.61,1.46-1.16,2.33-1.78,9.82-7.07,19.16-8.34,25.67-4.58L374.2,64c2.19,2.67.52,5.55,1.23,10L346.29,95l-.29.21Z",
    style: {
      fill: "#61A5C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.15,87.68l-5.32-21.57c.75-.61,1.46-1.16,2.33-1.78,9.82-7.07,19.16-8.34,25.67-4.58L374.2,64c2.19,2.67.52,5.55,1.23,10L346.29,95l-.29.21Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.6,92l-5.32-21.57c.74-.61,1.46-1.16,2.32-1.78,16.46-11.84,31.54-7.42,34.28,9.69l-29.14,21-.29.21Z",
    style: {
      fill: "#61A5C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.6,92l-5.32-21.57c.74-.61,1.46-1.16,2.32-1.78,16.46-11.84,31.54-7.42,34.28,9.69l-29.14,21-.29.21Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.83 66.11 346.27 70.41 353.45 99.49 346 95.19 338.83 66.11",
    style: {
      fill: "#61A5C2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.83 66.11 346.27 70.41 353.45 99.49 346 95.19 338.83 66.11",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.51,134.13c-4.82,2.54-9,6.05-12.95,5.9l-7.44-4.3c-3.9-2.22-6.78-6.31-8.22-12.13-2-8.11-.75-18.43,3.5-29.07a72.41,72.41,0,0,1,17.67-26l7.45,4.3-2.76,14.69,2.75,11.15Z",
    style: {
      fill: "#61A5C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.51,134.13c-4.82,2.54-9,6.05-12.95,5.9l-7.44-4.3c-3.9-2.22-6.78-6.31-8.22-12.13-2-8.11-.75-18.43,3.5-29.07a72.41,72.41,0,0,1,17.67-26l7.45,4.3-2.76,14.69,2.75,11.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,138.43c-13.82,7.29-25.22,3.18-28.6-10.53-2-8.11-.75-18.43,3.5-29.07a72.28,72.28,0,0,1,17.67-26l4.68,19L351,102.94Z",
    style: {
      fill: "#61A5C2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Envelope--inject-180"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.67,221.71a2.84,2.84,0,0,1,1.3-2.24l66.12-38.18a2.88,2.88,0,0,1,2.59,0l1.45.84a2.85,2.85,0,0,1,1.3,2.24v50.69a2.85,2.85,0,0,1-1.3,2.24L373,275.47a2.82,2.82,0,0,1-2.59,0l-1.45-.84a2.84,2.84,0,0,1-1.3-2.24Z",
    style: {
      fill: "#61A5C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.67,221.71a2.84,2.84,0,0,1,1.3-2.24l66.12-38.18a2.88,2.88,0,0,1,2.59,0l1.45.84a2.85,2.85,0,0,1,1.3,2.24v50.69a2.85,2.85,0,0,1-1.3,2.24L373,275.47a2.82,2.82,0,0,1-2.59,0l-1.45-.84a2.84,2.84,0,0,1-1.3-2.24Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.73,223.72l-5.68-3.29a2.73,2.73,0,0,0-.38,1.28v50.68a2.84,2.84,0,0,0,1.3,2.24l1.45.84a2.82,2.82,0,0,0,2.59,0l.72-.42Z",
    style: {
      fill: "#61A5C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.73,223.72l-5.68-3.29a2.73,2.73,0,0,0-.38,1.28v50.68a2.84,2.84,0,0,0,1.3,2.24l1.45.84a2.82,2.82,0,0,0,2.59,0l.72-.42Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.43,184.37v50.69a2.76,2.76,0,0,1-.4,1.31,2.82,2.82,0,0,1-.76.84l0,0-.08.06L373,275.47h0a.93.93,0,0,1-.88.1.9.9,0,0,1-.4-.85V224a1.11,1.11,0,0,1,1.45-1.14L401,229.51l3.64.86a2.4,2.4,0,0,0,2.32-.87l4.22-5.87,28.4-39.54C440,183.42,440.43,183.55,440.43,184.37Z",
    style: {
      fill: "#61A5C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.14,237.3l.08-.06,0,0a2.82,2.82,0,0,0,.76-.84,2.77,2.77,0,0,0,.4-1.29l-29.27-11.45,19.6,18.5Z",
    style: {
      fill: "#61A5C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.14,237.3l.08-.06,0,0a2.82,2.82,0,0,0,.76-.84,2.77,2.77,0,0,0,.4-1.29l-29.27-11.45,19.6,18.5Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.72,274.73a.9.9,0,0,0,.4.85.93.93,0,0,0,.88-.1h0l22.77-13.14,5.2-32.82-29.26,44.37Z",
    style: {
      fill: "#61A5C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.72,274.73a.9.9,0,0,0,.4.85.93.93,0,0,0,.88-.1h0l22.77-13.14,5.2-32.82-29.26,44.37Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,236.37a2.82,2.82,0,0,1-.76.84l0,0L373,275.47h0a.93.93,0,0,1-.88.1L403.78,225a5,5,0,0,1,6.23-1.91Z",
    style: {
      fill: "#61A5C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.72,222.55,402.13,236a5,5,0,0,0,6.23-1.92L440.29,183Z",
    style: {
      fill: "#61A5C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.72,222.55,402.13,236a5,5,0,0,0,6.23-1.92L440.29,183Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.72,222.55,402.34,234a5,5,0,0,0,5.91-1.94l32-49.09Z",
    style: {
      fill: "#61A5C2"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutDev2);
export default __webpack_public_path__ + "static/media/about_dev2.3c22acc0934aad5448f2f7d965f1fcb5.svg";
export { ForwardRef as ReactComponent };